import { Send, Instagram, Facebook } from "lucide-react";
import { SOCIAL_LINKS } from "../i18n";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const socials = [
  { key: "telegram", Icon: Send, href: SOCIAL_LINKS.telegram },
  { key: "instagram", Icon: Instagram, href: SOCIAL_LINKS.instagram },
  { key: "facebook", Icon: Facebook, href: SOCIAL_LINKS.facebook },
  { key: "tiktok", Icon: TikTokIcon, href: SOCIAL_LINKS.tiktok },
];

export const SocialIcons = ({ className = "", compact = false, iconSize = 18 }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {socials.map(({ key, Icon, href }) => (
      <a
        key={key}
        data-testid={`social-link-${key}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={key}
        className={`flex items-center justify-center rounded-full border border-white/15 bg-white/5 text-gray-300 transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#EAB308]/60 hover:text-[#EAB308] ${
          compact ? "h-9 w-9" : "h-10 w-10"
        }`}
      >
        <Icon style={{ width: iconSize, height: iconSize }} />
      </a>
    ))}
  </div>
);
